import Axios from '~/utils/axios';
import { useQuery } from 'react-query';
import { useTranslate } from '~/i18n';

const useHelpCenterVideos = () => {
   const { lang } = useTranslate();
   const getHelpCenterVideos = async () => {
      const { data } = await Axios.get(`hy-providers/v1/enablement/content-hub?lang=${lang}`);
      return data;
   };

   return useQuery(['help-center-videos', lang], getHelpCenterVideos);
};

export default useHelpCenterVideos;
